import { Box } from '@chakra-ui/react';

type BadgeTone = 'filter' | 'notice';

/**
 * Corner count badge.
 * - `filter`: muted coral for applied-filter FABs
 * - `notice`: brand accent for invites / join requests
 */
export function MobileFilterFabBadge({
  count,
  tone = 'filter',
}: {
  count: number;
  tone?: BadgeTone;
}) {
  if (count <= 0) return null;

  const isNotice = tone === 'notice';

  return (
    <Box
      position="absolute"
      top="-2px"
      right="-2px"
      minW="18px"
      h="18px"
      px="4px"
      borderRadius="full"
      bg={isNotice ? 'accent' : 'orange.700'}
      color={isNotice ? 'bg' : 'white'}
      fontSize="10px"
      fontWeight="bold"
      lineHeight="1"
      letterSpacing="-0.02em"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderWidth="1.5px"
      borderColor={isNotice ? 'bgElevated' : 'bg'}
      pointerEvents="none"
      zIndex={1}
      fontVariantNumeric="tabular-nums"
    >
      {count > 9 ? '9+' : count}
    </Box>
  );
}
